export const formatNumber = (val: number | string) => {
  if (!val && val !== 0) return "";

  const num = Number(val);
  if (isNaN(num)) return "";

  return num.toLocaleString("en-IN");
};
export const formatCurrency = (val: number | string) => {
  const formatted = formatNumber(val);
  return formatted ? `₹ ${formatted}` : "";
};
export const onlyDigits = (value: string) => {
  return value.replace(/\D/g, "");
};

export const limitDigits = (value: string, limit: number) => {
  return value.slice(0, limit);
};
export const formatAmount = (num: number) => {
  if (!num) return "₹ 0";

  if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(1)}Cr`;
  if (num >= 100000) return `₹ ${(num / 100000).toFixed(1)}L`;
  if (num >= 1000) return `₹ ${(num / 1000).toFixed(1)}K`;

  return `₹ ${num}`;
};